import * as React from 'react';
import { css, html } from 'react-strict-dom';

import Text from './Text';

type Props = Readonly<{
  title?: string;
  children: React.ReactNode;
}>;

export default function Box({ title, children }: Props) {
  return (
    <html.div style={styles.container}>
      {title && (
        <Text as="p" style={styles.title}>
          {title}
        </Text>
      )}
      <html.div>{children}</html.div>
    </html.div>
  );
}

const styles = css.create({
  container: {
    backgroundColor: '#fff',
    borderRadius: 5,
    boxShadow: '0 2px 5px rgba(51, 51, 79, 0.07)',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#eee',
  },
  title: {
    padding: 25,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#eee',
    color: '#444',
    fontSize: 20,
  },
});
